import {PROJECT_CATEGORY_NAME, ProjectCategory} from 'modules/project'
import {User} from 'modules/users'
import {formatDate} from 'common/helpers'

export const uniqueUsersFromProjects = (
  projects: any[],
  type: 'borrower' | 'manager'
): User[] => {
  const usersUuidSet = new Set<string>(
    projects.flatMap((project: any) => project[type] ? project[type].uuid : [])
  )
  return Array.from(usersUuidSet).map(
    (uuid) => projects.find((project) => project[type]?.uuid === uuid)[type]
  )
}

export const uniqueBorrowersFromProjects = (
  projects: any[]
): User[] => {

  const usersUuidSet = new Set<string>(
    projects.flatMap((project: any) => project.borrower ? project.borrower.id : [])
  )
  return Array.from(usersUuidSet).map(
    (uuid) => projects.find((project) => project.borrower?.id === uuid).borrower
  )
}

export const getProjectsReportData = (projects: any[]): any[] =>
  projects.map((item, index) => ({
    '#': index + 1,
    Title: item.title,
    Status: item.status,
    Description: item.description,
    Address: item.address,
    Region: item.region,
    'Loan type': item.categories
      .map((category: ProjectCategory) => PROJECT_CATEGORY_NAME[category])
      .join(', '),
    Units: item.units,
    Manager: item.manager.firstName,
    Borrower: `${item.borrower.firstName} ${item.borrower.lastName}`,
    'Open date': formatDate(item.openDate),
    'Maturity date': formatDate(item.maturityDate),
    'Irr forecast': item.xirr,
    Income: item.currentIncome,
    Undrawn: item.availableWithdrawal,
    'Loan balance': item.balance,
    'Facility limit 1': item.facilityLimit1,
    'Created date': formatDate(item.createdAt),
  }))

export const getActiveProjects = (projects: any[]): any[] =>
  projects?.filter((project: any) => !project.archived)

export const getArchivedProjects = (projects: any[]): any[] =>
  projects?.filter((project: any) => project.archived)
